<template>
  <div class="Thenav">
   
  <md-toolbar
    id="toolbar"
    style="background: linear-gradient(80deg,#f95050,#1818fa);"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
   <div class="md-toolbar-section-start logo">
        <div class="md-title">
          <a href="#/"><img src="../assets/img/logo.png" alt="spf"/></a>
        </div>
    </div>
    <div class="md-toolbar-row md-collapse-lateral">
      
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <li class="md-list-item" v-if="!showDownload">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <i class="material-icons">apps</i>
                        <p>Components</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#/">
                            <i class="material-icons">layers</i>
                            <p>All Components</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://demos.creative-tim.com/vue-material-kit/documentation/"
                          >
                            <i class="material-icons">content_paste</i>
                            <p>Documentation</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>

              <md-list-item href="#/aide"
                 @click="scrollToElement()">
                <i class="material-icons">help</i>
                <p>Guide d'utilisation</p>
              </md-list-item>

              <md-list-item
                href="#/download"
                @click="scrollToElement()"
                v-if="
                  $store.getters.isAuthenticated &&
                    $store.getters.user.typeutilisateur == 'Admin'
                "
              >
                <i class="material-icons">cloud_download</i>
                <p>Import des fichiers</p>
              </md-list-item>

              <md-list-item
                href="#/sendMail"
                @click="scrollToElement()"
                v-if="
                  $store.getters.isAuthenticated &&
                    ($store.getters.user.typeutilisateur == 'Admin' ||
                      $store.getters.user.typeutilisateur ==
                        'Responsable antenne')
                "
              >
                <i class="material-icons">create</i>
                <p>Créer un bénévole</p>
              </md-list-item>

              <md-list-item
                href="https://twitter.com/SecoursPop?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                target="_blank"
              >
                <i class="fab fa-twitter"></i>
                <p class="hidden-lg">Twitter</p>
                <md-tooltip md-direction="bottom"
                  >Follow us on Twitter</md-tooltip
                >
              </md-list-item>
              <md-list-item
                href="https://www.facebook.com/secourspopulaire/"
                target="_blank"
              >
                <i class="fab fa-facebook-square"></i>
                <p class="hidden-lg">Facebook</p>
                <md-tooltip md-direction="bottom"
                  >Like us on Facebook</md-tooltip
                >
              </md-list-item>
              <md-list-item
                href="https://www.instagram.com/secourspop/?hl=fr"
                target="_blank"
              >
                <i class="fab fa-instagram"></i>
                <p class="hidden-lg">Instagram</p>
                <md-tooltip md-direction="bottom"
                  >Follow us on Instagram</md-tooltip
                >
              </md-list-item>
              <md-list-item
               
                v-if="$store.getters.isAuthenticated"
              >
              <router-link to="/logout">
                <i class="fa fa-sign-out-alt"></i>
                <p class="hidden-lg">déconnexion</p>
                <md-tooltip md-direction="bottom">déconnexion</md-tooltip>
                </router-link>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
      <div style="position: left;">
        <!-- <b>{{this.user.nom + " " + this.user.prenom}}</b>  @click="logout" -->
      </div>
    </div>
  </md-toolbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "../http-common";
import router from "../router";
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
import { LOCAL_STORAGE } from "../utils/localStorage";
export default {
  components: {
    MobileMenu,
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
        ].includes(value);
      },
    },
    colorOnScroll: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapActions(["logoutUser"]),
    showDownload() {
      const excludedRoutes = ["login", "profile"];
      return excludedRoutes.every((r) => r !== this.$route.name);
    },
  },
  methods: {
    // logout
    async logout(evt) {
      evt.preventDefault();
      try {
        await axios.post("/api/auth/signout").then((response) => {
          console.log(response.data);
          console.log("dans then");

          LOCAL_STORAGE.REMOVE({ key: "auth" });
          // Vider le cache du navigateur
         window.location.reload(true);

          // Effacer les cookies
          document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          // this.logoutUser();
 
          router.go("/");
        });
      } catch (error) {
        console.error(error);
      }
      // console.log("logout en cours");
    },

    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    },
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
};
</script>
<style>
.logo{
  width: 30% !important;
  height: 100px;
}
</style>
